export const OFFER_STATUSES_KOLIBRI = {
  MANUAL_ACCEPTED: {
    name: 'MANUAL_ACCEPTED',
    editSatusName: 'MANUAL_ACCEPT',
    // Kolibri only: "Aksept (rådgiver)" must be read-only, so keep it disabled/non-clickable.
    editSatus: false,
    filterStatus: true
  },
  MANUAL_DECLINED: {
    name: 'MANUAL_DECLINED',
    editSatusName: 'MANUAL_DECLINE',
    editSatus: true,
    filterStatus: true
  },
  PRODUCED: {
    name: 'PRODUCED',
    editSatusName: 'MANUAL_PRODUCED',
    editSatus: true,
    filterStatus: true
  },
  GIVEN_MANUAL: {
    name: 'GIVEN_MANUAL',
    editSatusName: 'OFFER_GIVEN_MANUAL',
    editSatus: true,
    filterStatus: true,
  },
  DUPLICATE: {
    name: 'DUPLICATE',
    editSatusName: 'DUPLICATE_OFFER',
    filterStatus: true,
    editSatus: true
  },
  MANUAL_DELETE: {
    name: 'MANUAL_DELETE',
    editSatusName: 'MANUAL_DELETE',
    filterStatus: true,
    editSatus: true
  },
  LINK_CLICKED: {
    name: 'LINK_CLICKED',
    editSatus: false,
    filterStatus: true
  },
  INIT_SESSION: {
    name: 'INIT_SESSION',
    editSatus: false,
    filterStatus: true
  },
  OFFER_MANUAL_REVIEW: {
    name: 'OFFER_MANUAL_REVIEW',
    editSatus: false,
    filterStatus: true
  },
  OFFER_PROVIDED: {
    name: 'OFFER_PROVIDED',
    editSatus: false,
    filterStatus: true
  },
  OFFER_SENT_USER: {
    name: 'OFFER_SENT_USER',
    editSatus: false,
    filterStatus: true
  },
  SELECT_FLOW: {
    name: 'SELECT_FLOW',
    editSatus: false,
    filterStatus: true
  },
  CREDIT_CHECK_FAILED: {
    name: 'CREDIT_CHECK_FAILED',
    editSatusName: 'CREDIT_CHECK_FAILED',
    editSatus: true,
    filterStatus: true
  },
  VALIDATION_FAILED: {
    name: 'VALIDATION_FAILED',
    editSatus: false,
    filterStatus: true
  },
  PENDING: {
    name: 'PENDING',
    editSatus: false,
    filterStatus: true
  },
  ACCEPTED: {
    name: 'ACCEPTED',
    editSatus: false,
    filterStatus: true
  },
  DECLINED: {
    name: 'DECLINED',
    editSatus: false,
    filterStatus: true
  },
  BANKID_SSN_PROCESS_STARTED: {
    name: 'BANKID_SSN_PROCESS_STARTED',
    editSatus: false,
    filterStatus: true,
  },
  BANKID_SSN_VERIFYED: {
    name: 'BANKID_SSN_VERIFYED',
    editSatus: false,
    filterStatus: true
  },
  BANKID_SSN_CANCELED: {
    name: 'BANKID_SSN_CANCELED',
    editSatus: false,
    filterStatus: true,
  },
  FAILED: {
    name: 'FAILED',
    editSatus: false,
    filterStatus: false
  },
  EDITED: {
    name: 'EDITED',
    editSatus: false,
    filterStatus: true
  },
  UNDEFINED: {
    name: 'UNDEFINED',
    filterStatus: false,
    editSatus: false
  },
  SENT_OFFER_REMINDER: {
    name: 'SENT_OFFER_REMINDER',
    filterStatus: false,
    editSatus: false
  }
};
